import { type ITextContent } from '@/version-types';

type TextContentEnhanced = ITextContent & { originIdx: number };

export const getListTextWithRichText = (textContents: ITextContent[]) => {
    if (textContents.length === 0) return [];

    const ret: TextContentEnhanced[][] = [];
    let listItem: TextContentEnhanced[] = [];

    for (let i = 0; i < textContents.length; i++) {
        const item = textContents[i];
        const segments = item.text.split('\n');

        if (segments.length > 1) {
            for (let j = 0; j < segments.length; j++) {
                const segment = segments[j];
                if (segment) listItem.push({ ...item, text: segment, originIdx: i });

                if (j !== segments.length - 1) {
                    ret.push(listItem);
                    listItem = [];
                }
            }
        } else {
            listItem.push({ ...item, originIdx: i });
        }
    }

    if (listItem.length > 0) ret.push(listItem);

    return ret;
};
